import clsx from 'clsx';

import { MetaTag } from '~components/generic/MetaTag/MetaTag';
import useLabels from '~hooks/useLabels';
import { Image } from './Image';
import { LayoutVariant } from './LayoutVariant';

type ItemProps = {
  className?: string;
  variant?: LayoutVariant;
  title: string;
  description: string;
  LinkComponent?: React.ElementType;
  href?: string;
  imageSrc?: string;
  imageCrops?: ImageCrops;
  topics?: Topic[];
};

export function Item({
  title,
  description,
  className,
  variant = LayoutVariant.SMALL,
  LinkComponent = 'a',
  href,
  imageSrc,
  imageCrops,
  topics,
}: ItemProps) {
  const { btnNewsfeedLink } = useLabels(['btnNewsfeedLink']);

  return (
    <div
      className={clsx(
        'feed--item mb-4',
        {
          'col-span-2': variant === LayoutVariant.SMALL,
          'col-span-3': variant === LayoutVariant.BIG,
          'col-span-4': variant === LayoutVariant.WIDE,
          'col-span-6': variant === LayoutVariant.FULL,
        },
        className,
      )}
    >
      <div>
        <div
          className={clsx('bg-gray rounded-xl relative overflow-hidden', {
            'aspect-ratio-1/1': variant === LayoutVariant.SMALL || variant === LayoutVariant.BIG,
            'aspect-ratio-2/1': variant === LayoutVariant.WIDE || variant === LayoutVariant.FULL,
          })}
        >
          <LinkComponent href={href} className="absolute inset-0 block w-full h-full">
            <Image imageSrc={imageSrc} crops={imageCrops} variant={variant} />
          </LinkComponent>
          <div className="absolute top-0 left-0 mt-3 ml-3 flex gap-2 flex-wrap">
            {topics &&
              topics.map((topic, idx) => {
                if (variant === LayoutVariant.SMALL && idx > 0) return null; // On 'small' items show only the first meta tag
                return (
                  <MetaTag key={topic.id} color={topic.color} label={topic.label} child={Boolean(topic.parentId)} />
                );
              })}
          </div>
        </div>
      </div>
      <div className="feed-txt--blk">
        <div className="feed--title">{title}</div>
        <div className="feed--description">{description}</div>
        {!!href && (
          <div className="feed--link">
            <LinkComponent href={href}>{btnNewsfeedLink}</LinkComponent>
          </div>
        )}
      </div>
    </div>
  );
}
